import React from 'react';

type Props = {
  fullScreen?: boolean;
}

const AppLoader:React.FC<Props> = ({ fullScreen = true }) => {
  return (
    <div
      className={`
        ${fullScreen ? 'fixed top-0 left-0' : ''}
        w-full h-full
        flex items-center justify-center
      `}
      style={{
        background: 'linear-gradient(90deg, #0c141a 0%, #1d262d 100%)'
      }}
    >
      <div className="text-center">
        <div className="lds-ripple">
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
}

export default AppLoader;
